import { SET_PREVIEW_FILE, DESTROY_PREVIEW_FILE } from '../actions.type'
import { PREVIEW_FILE, DESTROY_FILE } from '../mutations.type'

const state = {
    spDocumentId: null,
    previewFiles: []
}

const getters = {
    getPreviewFile: (state) => state.previewFiles,
    getDocumentId: (state) => state.spDocumentId
}

const actions = {
  [SET_PREVIEW_FILE] (context, data) {
    context.commit(PREVIEW_FILE, data)
  },
  [DESTROY_PREVIEW_FILE] (context) {
    context.commit(DESTROY_FILE)
  }
}

const mutations = {
  [PREVIEW_FILE] (state, data) {
    state.spDocumentId = data.spDocumentId
    state.previewFiles.push(data.previewFile)
  },
  [DESTROY_FILE] (state) {
    state.spDocumentId = null
    state.previewFiles = []
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
